import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
type TrustBadgesProps = {
  tone?: 'light' | 'dark';
  className?: string;
  paymentLabel?: string;
  guaranteeLabel?: string;
};
export function TrustBadges({
  tone = 'light',
  className = '',
  paymentLabel = 'Mercado Pago',
  guaranteeLabel = 'Garantía 7 días'
}: TrustBadgesProps) {
  const text = tone === 'dark' ? 'text-white/80' : 'text-body-muted';
  const icon = tone === 'dark' ? 'text-sage' : 'text-sage-deep';
  const items = [{
    Icon: LockIcon,
    label: 'Pago 100% seguro'
  }, {
    Icon: ZapIcon,
    label: 'Acceso en 5 minutos'
  }, {
    Icon: ShieldCheckIcon,
    label: guaranteeLabel
  }, {
    Icon: CreditCardIcon,
    label: paymentLabel
  }];
  return <ul className={`flex flex-wrap items-center gap-x-6 gap-y-2 text-sm font-medium ${text} ${className}`} data-id="element-341" data-mp="3h7p130t44qvv">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-2" data-id="element-342" data-mp="3q83nk3htcc0y">
          <Icon className={`h-4 w-4 shrink-0 ${icon}`} aria-hidden="true" data-id="element-343" data-mp="3q5qyl6dn11ee" />
          {label}
        </li>)}
    </ul>;
}